/**
 * These constants represent the numbers that virtual dropdown/combobox/autocomplete should use.
 */
export default {
    height: 253,
    itemHeight: 23,
    pageSize: 44
}
